export default (pixel: number, BASE_FONT_SIZE_NUMBER: number) =>
  `${(pixel / BASE_FONT_SIZE_NUMBER).toFixed(2)}rem`
